import { render, staticRenderFns } from "./RoleDetailsCard.vue?vue&type=template&id=3a3be6b2&scoped=true&"
import script from "./RoleDetailsCard.vue?vue&type=script&lang=js&"
export * from "./RoleDetailsCard.vue?vue&type=script&lang=js&"
import style0 from "./RoleDetailsCard.vue?vue&type=style&index=0&id=3a3be6b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3be6b2",
  null
  
)

export default component.exports